import { useEffect, useState } from 'react'

/**
 * Programmatic mirror of the VTT shell's CSS breakpoint (≤768px = mobile).
 * The layout itself is driven by `@media` queries, but a few components need
 * to *switch which panel they mount* (desktop big card vs compact HUD), which
 * CSS alone can't do. SSR-safe: defaults to desktop until the client mounts.
 */
const MOBILE_QUERY = '(max-width: 768px)'

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(
    () =>
      typeof window !== 'undefined' &&
      !!window.matchMedia?.(MOBILE_QUERY).matches,
  )

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mql = window.matchMedia(MOBILE_QUERY)
    const onChange = () => setIsMobile(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  return isMobile
}
